var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 358.49,
    rx: 222.5,
    ry: 128.46,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.58,
    cy: 369.76,
    rx: 24.63,
    ry: 14.22,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.26,293.53,123.38,387a4,4,0,0,0,0,7l95.14,54.93a15.73,15.73,0,0,0,15.73,0l161.88-93.46a4,4,0,0,0,0-7L301,293.53A15.73,15.73,0,0,0,285.26,293.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,294.44l-64.8,37.42a8.55,8.55,0,0,0,0,14.82l32.63,18.84a14.23,14.23,0,0,0,14.2,0l64.81-37.42a8.56,8.56,0,0,0,0-14.82l-32.64-18.84A14.18,14.18,0,0,0,236.65,294.44Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.88,333s-15.22-14.87-6.56-39.77c4.85-13.95,20.94-24.2,30.1-25.16a42.92,42.92,0,0,0-7.16,12.07l-11.54,7.67,10.61-3.32-2.26,9.08s-9.86,6-11.32,7.26L109.38,298S108.56,323.72,96.88,333Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,333s-15.22-14.87-6.56-39.77c4.85-13.95,20.94-24.2,30.1-25.16a42.92,42.92,0,0,0-7.16,12.07l-11.54,7.67,10.61-3.32-2.26,9.08s-9.86,6-11.32,7.26L109.38,298S108.56,323.72,96.88,333Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,333s-7.88-31.11,3.78-49.25C100.66,283.71,87,299.72,96.88,333Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,337.17l-18.63-.24h-.19l-18.62.24s-.21,22.94,6.86,32.27h0c2,2.49,6.53,4.23,11.86,4.23s9.92-1.75,11.87-4.24C114.5,360.09,114.3,337.17,114.3,337.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.58,
    cy: 337.17,
    rx: 18.72,
    ry: 10.05,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,334.5c6.44,0,11.89,2.07,13.81,4.93a4,4,0,0,0,.75-2.26c0-4-6.52-7.19-14.56-7.19S81,333.2,81,337.17a4.08,4.08,0,0,0,.74,2.26C83.68,336.57,89.14,334.5,95.58,334.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.58,
    cy: 339.43,
    rx: 13.81,
    ry: 4.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,340.67s-7.22-.28-13.4-9.86c-2.56-3.95-3.79-6-3.79-6l10-.75-11.26-2.81-5.32-8.14,9.35-.7s-7-2.44-11.93-2.47c0,0-8.63-15.23-11.15-17.4a48.89,48.89,0,0,1,34.07,16.92C106.6,326.19,97.91,341.1,95.81,340.67Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,340.67s4.51-27.18-24.28-43.52C71.53,297.15,101.41,311.5,95.81,340.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,340.67s6.53.42,13-7.64c2.67-3.32,4-5.08,4-5.08l-9-1.62,10.42-1.48L119.8,318l-8.37-1.51s6.51-1.54,11-1.1c0,0,9.22-12.94,11.7-14.66a44.36,44.36,0,0,0-32.33,12.07C87.43,326.59,93.87,340.86,95.81,340.67Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,340.67s6.53.42,13-7.64c2.67-3.32,4-5.08,4-5.08l-9-1.62,10.42-1.48L119.8,318l-8.37-1.51s6.51-1.54,11-1.1c0,0,9.22-12.94,11.7-14.66a44.36,44.36,0,0,0-32.33,12.07C87.43,326.59,93.87,340.86,95.81,340.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,340.67s-1.52-24.94,26-37C121.81,303.69,93.5,313.83,95.81,340.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "128.91 119.4 128.91 169.08 85.88 193.92 85.88 144.24 128.91 119.4 128.91 119.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,122.09v44.3L85.88,188.54v-44.3l38.37-22.15m2.33-4-43,24.84v49.68l2.33,1.35,43-24.84V119.4l-2.33-1.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.58,123.43v44.3L88.21,189.88v-44.3l38.37-22.15m2.33-4-43,24.84v49.68l43-24.84V119.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.59 157.71 90.04 176.5 99.66 151.49 106.32 159.39 113.13 149.7 122.59 157.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,142.1a6.57,6.57,0,0,1-3,5.15c-1.64.94-3,.18-3-1.72a6.57,6.57,0,0,1,3-5.14C110,139.44,111.3,140.21,111.3,142.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.26 57.55 143.26 97.12 108.99 116.91 108.99 77.33 143.26 57.55 143.26 57.55",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55,59.69V95L109,112.63V77.33l30.56-17.64m1.86-3.22L107.13,76.26v39.58l1.86,1.07,34.27-19.79V57.54l-1.85-1.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41,60.76V96.05L110.84,113.7V78.4l30.57-17.64m1.85-3.22L109,77.33v39.58l34.27-19.79V57.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.23 88.07 112.3 103.04 119.96 83.11 125.27 89.41 130.69 81.68 138.23 88.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,75.63a5.22,5.22,0,0,1-2.37,4.1c-1.31.76-2.36.14-2.36-1.36a5.21,5.21,0,0,1,2.36-4.1C128.18,73.51,129.24,74.13,129.24,75.63Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.15,286.33l13.91,84.89a2.65,2.65,0,0,0,2.62,2.22h0a2.65,2.65,0,0,0,2.63-2.94l-9.76-87.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.17,257.78l13.92,84.89a2.64,2.64,0,0,0,2.61,2.22h0a2.65,2.65,0,0,0,2.63-2.95l-9.76-87.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,266.48l-13.73,73.15a2.21,2.21,0,0,1-2.19,1.82,2.24,2.24,0,0,1-2.21-2.56l10.14-67.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,239.19l-13.65,72.7a2.21,2.21,0,0,1-2.19,1.82,2.24,2.24,0,0,1-2.21-2.55l10.06-67.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,233.65a19.46,19.46,0,0,1-11.49-15.87c-2.21-22.28-10.06-68.18-36.64-52.9-32.82,18.86-21.07,73.63-16.3,91.19a23.71,23.71,0,0,0,6,10.49c5.93,6,18.2,16.26,39.08,25a12.26,12.26,0,0,0,8.08.48c10.37-2.95,37.46-12,51-29.3a4.72,4.72,0,0,0-.78-6.6C272.88,251.8,260.51,243.07,239.4,233.65Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,233.65a19.46,19.46,0,0,1-11.49-15.87c-2.21-22.28-10.06-68.18-36.64-52.9-32.82,18.86-21.07,73.63-16.3,91.19a23.71,23.71,0,0,0,6,10.49c5.93,6,18.2,16.26,39.08,25a12.26,12.26,0,0,0,8.08.48c10.37-2.95,37.46-12,51-29.3a4.72,4.72,0,0,0-.78-6.6C272.88,251.8,260.51,243.07,239.4,233.65Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.11,259.61a4.68,4.68,0,0,1-1,3.14c-.72.93-1.49,1.82-2.28,2.7h0c-.44.48-.88.95-1.34,1.41l0,0c-.45.46-.91.91-1.38,1.36l0,0-1.42,1.32,0,0c-.49.43-1,.86-1.49,1.28v0c-7.67,6.43-17,11.33-25.27,14.86h0l-1.54.65-.16.06-1.42.58-.25.09-1.32.52-.3.12-1.23.46-.36.13-1.14.42-.41.15-1.05.37-.43.15-1,.33-.47.16-.88.29-.5.17-.79.25-.54.17-.68.22-.58.17-.57.18-.71.21-.36.1c-.34.11-.68.2-1,.29a12.26,12.26,0,0,1-8.08-.48c-20.88-8.75-33.15-19-39.08-25a23.71,23.71,0,0,1-6-10.49c-4.77-17.56-16.52-72.33,16.3-91.19q.87-.49,1.71-.9l.37-.18c.56-.26,1.1-.5,1.64-.71l.16-.06c.51-.19,1-.36,1.52-.5l.23-.07c.54-.15,1.07-.27,1.59-.37l.14,0a14.74,14.74,0,0,1,3.14-.22h.06a13.24,13.24,0,0,1,3,.46h0c-5.24-2.31-11.64-2.21-18,1.44-32.82,18.86-21.07,73.63-16.3,91.19l.81,3a28.54,28.54,0,0,0,10.24,15.31l8.52,6.51h0A133.87,133.87,0,0,0,220,296.82a12.28,12.28,0,0,0,8.11.5c10.36-2.95,37.47-12,51-29.3a4.67,4.67,0,0,0,1-2.57h0V259.6Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.11,259.61a4.68,4.68,0,0,1-1,3.14c-.72.93-1.49,1.82-2.28,2.7h0c-.44.48-.88.95-1.34,1.41l0,0c-.45.46-.91.91-1.38,1.36l0,0-1.42,1.32,0,0c-.49.43-1,.86-1.49,1.28v0c-7.67,6.43-17,11.33-25.27,14.86h0l-1.54.65-.16.06-1.42.58-.25.09-1.32.52-.3.12-1.23.46-.36.13-1.14.42-.41.15-1.05.37-.43.15-1,.33-.47.16-.88.29-.5.17-.79.25-.54.17-.68.22-.58.17-.57.18-.71.21-.36.1c-.34.11-.68.2-1,.29a12.26,12.26,0,0,1-8.08-.48c-20.88-8.75-33.15-19-39.08-25a23.71,23.71,0,0,1-6-10.49c-4.77-17.56-16.52-72.33,16.3-91.19q.87-.49,1.71-.9l.37-.18c.56-.26,1.1-.5,1.64-.71l.16-.06c.51-.19,1-.36,1.52-.5l.23-.07c.54-.15,1.07-.27,1.59-.37l.14,0a14.74,14.74,0,0,1,3.14-.22h.06a13.24,13.24,0,0,1,3,.46h0c-5.24-2.31-11.64-2.21-18,1.44-32.82,18.86-21.07,73.63-16.3,91.19l.81,3a28.54,28.54,0,0,0,10.24,15.31l8.52,6.51h0A133.87,133.87,0,0,0,220,296.82a12.28,12.28,0,0,0,8.11.5c10.36-2.95,37.47-12,51-29.3a4.67,4.67,0,0,0,1-2.57h0V259.6Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,322.28c-2.24-14.29-5.11-37.13-6.75-50.63q-.16-1.33-.45-2.64a28,28,0,0,0-13.21-17.89l-33.66-20-22.85-12s-6.08,17.62,1,28.4c5.88,9,31.84,20.08,39.56,23.83s7.88,4.76,7.72,9.77-.17,11.39,9.31,31.37c2.73,5.74,4.63,10,5.95,13.33A21,21,0,0,0,298.21,322.28Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,322.28c-2.24-14.29-5.11-37.13-6.75-50.63a28.43,28.43,0,0,0-.76-3.93,27.93,27.93,0,0,0-12.85-16.57l-33.71-20.07-22.85-12s-6.08,17.62,1,28.4c5.88,9,31.84,20.08,39.56,23.83s7.88,4.76,7.72,9.77-.17,11.39,9.31,31.37c2.73,5.74,4.63,10,5.95,13.33A21,21,0,0,0,298.21,322.28Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8,337.41a3.39,3.39,0,0,0,.41,1.7,23.72,23.72,0,0,0,5.06,6c4.54,4.09,19.57,20.1,24.85,10.16,0,0-15.53-14.87-17.58-21a101.83,101.83,0,0,1-2.33-12,21,21,0,0,1-13.4,3.48C287.72,333,287.85,335.35,287.8,337.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,336.43l-.43-1.29a2,2,0,0,0-2.42-1.24l-6.29,1.94a1.93,1.93,0,0,0-1.36,1.85v.63a1.13,1.13,0,0,1-1.13,1.12h0a5.73,5.73,0,0,1-3.65-1.31l-.88-.72v-2.2h0a3.87,3.87,0,0,0-1.75,3.44c.08,1.49.15,3.31.09,4-.1,1.32-1.33,6.82.14,8.45s4.77,1.82,8.85,1.38,8.54,3.57,12.32,5.06,19.44,4.69,19.4-5.32c0-2.55-2.53-3.59-5-4.49s-11.41-4.05-13.7-5.94a21,21,0,0,1-2.55-2.52A8.35,8.35,0,0,1,304,336.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,357.57c-3.78-1.49-8.24-5.5-12.32-5.06s-7.38.25-8.85-1.38a3.91,3.91,0,0,1-.7-2.31c-.07,1.54.05,3,.7,3.74,1.47,1.63,4.77,1.82,8.85,1.38s8.54,3.58,12.32,5.06,19.44,4.69,19.4-5.32a3.18,3.18,0,0,0-.06-.43C325.81,362,311.1,359,307.45,357.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,339.62c-2.25-14.28-5.11-37.12-6.76-50.63a28.42,28.42,0,0,0-9.82-18.24l-40.39-34.34L189.08,236s-4.45,18,2.61,28.77c5.89,9,31.84,20.09,39.56,23.83s7.88,4.77,7.72,9.77-.17,11.39,9.32,31.37c2.72,5.75,4.62,10,5.94,13.33A21.06,21.06,0,0,0,267.64,339.62Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,339.62c-2.25-14.28-5.11-37.12-6.76-50.63a28.42,28.42,0,0,0-9.82-18.24l-40.39-34.34L189.08,236s-4.45,18,2.61,28.77c5.89,9,31.84,20.09,39.56,23.83s7.88,4.77,7.72,9.77-.17,11.39,9.32,31.37c2.72,5.75,4.62,10,5.94,13.33A21.06,21.06,0,0,0,267.64,339.62Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.21,353.46c0,.6-.41,2.37.42,3,1.06.79,2.07,3.32,5.07,6,4.53,4.09,9.32-4.72,7.26-10.83a102.85,102.85,0,0,1-2.32-12,21.06,21.06,0,0,1-13.41,3.48C257.15,350.33,257.27,351.41,257.21,353.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,161.52h0a13.22,13.22,0,0,1,14.61,8.86,57.45,57.45,0,0,1,2.73,13.22c1.17,13.85,1.49,20.77,1.49,20.77l13.91,6.31s-7.51.36-7,11l-17.33-4.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,196c-2.05-15-2.86-22.85-4.62-26.57a13.49,13.49,0,0,0-14.72-7.91l5.24,41.2.67-.06a21.78,21.78,0,0,0,12.47-5.52Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,196c-2.05-15-2.86-22.85-4.62-26.57a13.49,13.49,0,0,0-14.72-7.91l5.24,41.2.67-.06a21.78,21.78,0,0,0,12.47-5.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.35,204.37a9.62,9.62,0,0,0-4.11,2.53s1.68-3.19,4-4.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.1,173.67l15.56-7.54,12.82-4.43s10.28-3.27,12.9,10.42c2.17,11.25,2.45,54,2.45,54l-.23,4.67s-5.93,16.62-27.12,18-25.32-7.56-25.32-7.56S186,184.66,197.1,173.67Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,128s4.81,12.33-1.83,17.76S240,129.33,240,129.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.81,198.49,140,283.83v18.49h0v89.85h0a1.86,1.86,0,0,0,1.12,1.67,6,6,0,0,0,5.46,0,1.86,1.86,0,0,0,1.11-1.67h0v-85.4L227.83,353v90.73h0a1.86,1.86,0,0,0,1.12,1.66,6,6,0,0,0,5.46,0,1.86,1.86,0,0,0,1.12-1.66h0V353l136.23-78.65v86h0A1.85,1.85,0,0,0,372.9,362a6,6,0,0,0,5.46,0,1.85,1.85,0,0,0,1.12-1.66h0V251.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.41,445.41a6,6,0,0,1-5.46,0c-1.51-.87-1.51-2.28,0-3.15a6,6,0,0,1,5.46,0C235.92,443.13,235.92,444.54,234.41,445.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.83,
    y: 350.79,
    width: 7.72,
    height: 92.96,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.87,
    cy: 392.27,
    rx: 3.86,
    ry: 2.23,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.01,
    y: 299.23,
    width: 7.72,
    height: 92.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.36,362a6,6,0,0,1-5.46,0c-1.51-.87-1.51-2.28,0-3.15a6,6,0,0,1,5.46,0C379.87,359.73,379.87,361.14,378.36,362Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.78,
    y: 267.39,
    width: 7.72,
    height: 92.96,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,291.66a5.42,5.42,0,0,1-4.9,0c-1.35-.78-1.35-2,0-2.82a5.36,5.36,0,0,1,4.9,0C285.31,289.62,285.31,290.88,284,291.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.05,
    y: 212.6,
    width: 6.93,
    height: 77.58,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140 283.83 140 302.32 231.69 355.26 231.69 336.76 140 283.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.5 251.43 231.69 336.76 231.69 355.26 379.5 269.92 379.5 251.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.81 198.49 140 283.83 231.69 336.76 379.5 251.43 287.81 198.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.66 256.08 247.28 275.49 303.17 243.16 269.56 223.36 213.66 256.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.66 250.55 256.27 243.27 248.37 238.71 235.76 245.99 243.66 250.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.71 270.64 231.72 260.64 264.92 240.54 248.71 270.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.22,208.28l13.45,6.31a117.87,117.87,0,0,1,11.87,3.67s9.36,3.82,9.79,6.33-7,8.56-13.57,5.62a20.71,20.71,0,0,0-5.46-2c-1.75-.19-7-1-10.75-4.61l-15.69-4.08S247.08,209.84,258.22,208.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.93,227c1.55,1.67,6,5.88,7,7.1s3.26-1.91-.75-6.58a37.63,37.63,0,0,1-9.69-5.27A38.28,38.28,0,0,0,266.93,227Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.66,
    y: 146.81,
    width: 15.96,
    height: 19.32,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,166.13A25.69,25.69,0,0,1,214,152.18v-5.37h14.67Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,121.3s14.52,1.75,11.19,26.56c-1.54,11.47-4.61,17.27-13.45,16.29-10-1.12-23.87-8.9-21.72-28.56S234,121.3,234,121.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.81 143.42 234.29 151.99 239.4 150.76 234.81 143.42",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.21,142.65a1.75,1.75,0,1,0,1.85-1.64A1.75,1.75,0,0,0,227.21,142.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,142.14a1.75,1.75,0,1,0,1.86-1.64A1.75,1.75,0,0,0,238.76,142.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,138.74l-3.29-2.24s1.39-1.28,2.65-.38A2.39,2.39,0,0,1,242.86,138.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,138.35l-3.55,1.78s-.44-1.84.95-2.49A2.38,2.38,0,0,1,228.42,138.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.54,155.47a8.93,8.93,0,0,1-5.53-1.85s-.56,2.94,1.88,3.65S234.54,155.47,234.54,155.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.49,143.22s2.23,4.65,3.61,4.49,0-17.81,2.86-17.92,16.36,6.59,28.29-2.06c4.59-3.32,5.5-11.8,2.75-11s-6.46,3.21-11.47,2.87-22.55-8.48-26.9,3c0,0-9.7-.79-6.06,18.47.91,4.79,3.77,16.65,7.09,17.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28,147.46a9.79,9.79,0,0,0-.79-4.24,4.5,4.5,0,0,0-3.89-3c-4.48-.12-5.09,4.2-5,5.73.16,4,3.43,8.4,9.51,8.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.66,233.91,226.1,243a38.42,38.42,0,0,1,5.8,1c2.19.65,7.93,2.76,9.45,3.09s-.44,3-4.42,2c0,0,8.34,5.71,8.23,8.25s-8.67,6.88-14.45,2.62a21.4,21.4,0,0,0-4.91-3.08c-1.68-.55-6.61-2.46-9.54-6.78l-10-5.21S203.44,233.08,214.66,233.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,171.21s6.67,5.17,2.57,21.24-6.29,29.92-6.29,29.92l16.2,11.54a14.28,14.28,0,0,0-8.4,11s-25.54-10-26.06-16.49,5.33-34.35,6.22-39.48S191.85,173.64,202.18,171.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,222.37a15.12,15.12,0,0,0-6.11.06,12.8,12.8,0,0,1,6.25-1.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,206.13l-5.85,38.25a.1.1,0,0,1,0,.07L247,278.12a.09.09,0,0,1-.13-.09l5.67-37.1a5.5,5.5,0,0,1,2.56-3.86l53.26-32.66A1.72,1.72,0,0,1,311,206.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,278.12l-31-18a4.72,4.72,0,0,1-2.35-4.08h0l33.62,19.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,243c0,2.74,1.92,3.84,4.28,2.48a9.47,9.47,0,0,0,4.29-7.42c0-2.74-1.92-3.84-4.29-2.48A9.49,9.49,0,0,0,277.37,243Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,128.21s-2.64-3.9-1-5.16S215,125.8,213.17,128.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,129s-4.66-.58-4.55-2.62S213,126.06,213.61,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.66,166.13s3.43,9,11.33,7.88,4.64-7.88,4.64-7.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,171.21s5.2,2.49,4.4,12.95-4.93,31.54-4.93,31.54-18.61,7.54-20.39-3.09c-.45-2.75,4.24-28.18,8.25-33.56A18.94,18.94,0,0,1,202.18,171.21Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.18,171.21s5.2,2.49,4.4,12.95-4.93,31.54-4.93,31.54-18.61,7.54-20.39-3.09c-.45-2.75,4.24-28.18,8.25-33.56A18.94,18.94,0,0,1,202.18,171.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,354a5.05,5.05,0,0,0,3,2.12c1.13.18-1.15-2.75,1.57-3.93s8.95-2.79,9.51-.45l.69,2.92a17.31,17.31,0,0,0,3.84,7.45,36.42,36.42,0,0,0,6.16,5.89c3.56,2.29,9.41,7.84,1.9,12.57s-16.73.73-18.54-4.64-3.72-6.93-4.68-7.82a10.25,10.25,0,0,1-4.06-5.92,56.39,56.39,0,0,1-1-7.2,2.71,2.71,0,0,1,1.24-2.49h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,380.55c-7.51,4.72-16.73.73-18.54-4.64s-3.72-6.93-4.68-7.82a10.8,10.8,0,0,1-3.75-4.87c0,.14,0,.3,0,.44.29,4.65,3.14,5.74,4.1,6.64s2.54,2.36,4.35,7.74,11.33,8.72,18.83,4c3.65-2.29,4.14-4.78,3.28-7C288.11,376.85,287.19,378.76,284.34,380.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,309.16,224.34,323l-30.2-17.44,24-13.84a2.1,2.1,0,0,1,2.06,0l28.09,16.22A.71.71,0,0,1,248.26,309.16Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,309.16,224.34,323l-30.2-17.44,24-13.84a2.1,2.1,0,0,1,2.06,0l28.09,16.22A.71.71,0,0,1,248.26,309.16Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,308.66l-22.26,12.85-28.11-16.22,22.31-12.88a1.87,1.87,0,0,1,1.91,0L246.6,307.5A.67.67,0,0,1,246.6,308.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.34 321.51 224.34 319 246.94 305.96 246.94 308.09 224.34 321.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.34 321.51 224.34 319 196.23 302.78 196.23 305.29 224.34 321.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,305.19,224.34,319l-30.2-17.43,24-13.84a2.1,2.1,0,0,1,2.06,0L248.26,304A.71.71,0,0,1,248.26,305.19Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,305.19,224.34,319l-30.2-17.43,24-13.84a2.1,2.1,0,0,1,2.06,0L248.26,304A.71.71,0,0,1,248.26,305.19Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,321.17a.49.49,0,0,1-.44,0,.55.55,0,0,1-.29-.48V318.4a3,3,0,0,1,1.45-2.54l.09-.06a.27.27,0,0,1,.4.24.47.47,0,0,0,.94,0,1.19,1.19,0,0,0-.61-1.05,1.17,1.17,0,0,0-1.21,0l-.09.05a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.45,1.45,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74,318.59a.49.49,0,0,1-.44,0,.55.55,0,0,1-.29-.48v-2.27a3,3,0,0,1,1.45-2.55l.09,0a.28.28,0,0,1,.27,0,.27.27,0,0,1,.13.23.47.47,0,1,0,.94,0,1.19,1.19,0,0,0-.61-1,1.17,1.17,0,0,0-1.21,0l-.09.05a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.45,1.45,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.27,316a.52.52,0,0,1-.44,0,.55.55,0,0,1-.29-.48v-2.27a3,3,0,0,1,1.45-2.55l.09-.05a.28.28,0,0,1,.27,0,.27.27,0,0,1,.13.23.47.47,0,1,0,.94,0,1.19,1.19,0,0,0-.61-1,1.17,1.17,0,0,0-1.21,0l-.09.05a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.45,1.45,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8,313.43a.52.52,0,0,1-.44,0,.55.55,0,0,1-.29-.48v-2.27a3,3,0,0,1,1.45-2.55l.09-.05a.28.28,0,0,1,.27,0,.27.27,0,0,1,.13.23.47.47,0,0,0,.94,0,1.19,1.19,0,0,0-.61-1,1.17,1.17,0,0,0-1.21,0l-.09.05a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.45,1.45,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,310.85a.52.52,0,0,1-.44,0,.55.55,0,0,1-.29-.48v-2.27a3,3,0,0,1,1.45-2.55l.09,0a.28.28,0,0,1,.27,0,.27.27,0,0,1,.13.23.47.47,0,0,0,.94,0,1.19,1.19,0,0,0-.61-1,1.17,1.17,0,0,0-1.21,0l-.09.05a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.57,1.57,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.86,308.27a.52.52,0,0,1-.44,0,.55.55,0,0,1-.29-.48V305.5a3,3,0,0,1,1.45-2.55l.09-.05a.28.28,0,0,1,.27,0,.25.25,0,0,1,.13.23.47.47,0,1,0,.94,0,1.22,1.22,0,0,0-1.82-1l-.09.06a3.9,3.9,0,0,0-1.91,3.35v2.27a1.49,1.49,0,0,0,.78,1.31,1.57,1.57,0,0,0,.7.17,1.47,1.47,0,0,0,.83-.25.44.44,0,0,0,.18-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.34 298.95 225.48 313.88 191.82 294.45 217.69 279.52 251.34 298.95",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.83 298.46 225.81 311.18 193.89 288.99 220.92 276.28 252.83 298.46",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,258.75H170.55l2,23.23h0a4.63,4.63,0,0,0,2.62,3.4,14.07,14.07,0,0,0,12.76,0,4.66,4.66,0,0,0,2.62-3.4h0Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9,257.48v-1.84h-.43a7.51,7.51,0,0,0-3.19-3.2c-4.83-2.79-12.67-2.79-17.5,0a7.45,7.45,0,0,0-3.19,3.2h-.44v1.86c0,1.82,1.21,3.65,3.63,5.05,4.83,2.79,12.67,2.79,17.5,0C192.7,261.15,193.91,259.31,193.9,257.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.28,260.8c-4.83,2.79-12.67,2.79-17.5,0s-4.84-7.31,0-10.1,12.67-2.8,17.5,0S195.11,258,190.28,260.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.45,255v-1.47h-.35a6,6,0,0,0-2.56-2.56,15.47,15.47,0,0,0-14,0,5.92,5.92,0,0,0-2.56,2.56h-.35V255c0,1.47,1,2.94,2.91,4.05a15.47,15.47,0,0,0,14,0C190.48,257.92,191.45,256.45,191.45,255Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,257.64a15.47,15.47,0,0,1-14,0c-3.88-2.23-3.88-5.86,0-8.09a15.47,15.47,0,0,1,14,0C192.41,251.78,192.41,255.41,188.54,257.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,256.46a11.93,11.93,0,0,1-10.79,0c-2.89-1.66-3-4.32-.3-6a2.49,2.49,0,0,1,.3-.19,9,9,0,0,1,2.08-.86,12,12,0,0,1,8.71.86C189.91,252,189.91,254.74,186.92,256.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,251.12a11.89,11.89,0,0,1,10.8,0,4,4,0,0,1,2.19,2.67c.23-1.27-.51-2.59-2.19-3.56a12,12,0,0,0-10.8,0c-1.69,1-2.42,2.29-2.2,3.56A4,4,0,0,1,176.13,251.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,251.41,178,252.82l-2.16-1.55v-.85a2.49,2.49,0,0,1,.3-.19,9,9,0,0,1,2.08-.86V250Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.86,115,316.38,43.08a3.05,3.05,0,0,0-3.62,0l-4.31,3,2.94,3.64V150.07c0,3.68,2.24,8,5,9.54l123.25,71.16.23,3.91,4.54-3.11a4.7,4.7,0,0,0,1.46-3.86V124.49C445.86,120.81,443.62,116.54,440.86,115Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,115,316.38,43.08a3.05,3.05,0,0,0-3.62,0l-4.31,3,2.94,3.64V150.07c0,3.68,2.24,8,5,9.54l123.25,71.16.23,3.91,4.54-3.11a4.7,4.7,0,0,0,1.46-3.86V124.49C445.86,120.81,443.62,116.54,440.86,115Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,234.4,312.14,162.53c-2.75-1.59-5-5.86-5-9.54V49.77c0-3.67,2.24-5.36,5-3.77l124.48,71.87c2.76,1.59,5,5.86,5,9.54V230.62C441.62,234.3,439.38,236,436.62,234.4Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,234.4,312.14,162.53c-2.75-1.59-5-5.86-5-9.54V49.77c0-3.67,2.24-5.36,5-3.77l124.48,71.87c2.76,1.59,5,5.86,5,9.54V230.62C441.62,234.3,439.38,236,436.62,234.4Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,117.87,312.14,46c-2.75-1.59-5,.1-5,3.77v5l134.47,77.63v-5C441.62,123.73,439.38,119.46,436.62,117.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,46.4h0a3.08,3.08,0,0,1,1.48.46l124.48,71.87c2.44,1.41,4.5,5.38,4.5,8.68V230.62c0,2-.79,3.38-2,3.38a3.06,3.06,0,0,1-1.49-.47L312.64,161.66c-2.43-1.4-4.49-5.38-4.49-8.67V49.77c0-2.05.79-3.37,2-3.37m0-1c-1.77,0-3,1.63-3,4.37V153c0,3.68,2.24,7.95,5,9.54L436.62,234.4a4,4,0,0,0,2,.6c1.77,0,3-1.64,3-4.38V127.41c0-3.68-2.24-8-5-9.54L312.14,46a3.94,3.94,0,0,0-2-.6Z",
    style: {
      fill: "#1C9F43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,100a1,1,0,0,1-.53-.14L316.94,72.54A1.06,1.06,0,0,1,318,70.71l47.39,27.36a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.53,138.54a1,1,0,0,1-.53-.15l-35.1-20.26a1.06,1.06,0,1,1,1.06-1.84l35.1,20.27a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,113.88a1.13,1.13,0,0,1-.53-.14L374,105.5a1.06,1.06,0,1,1,1.06-1.83l14.26,8.23a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,166.41a1.1,1.1,0,0,1-.53-.14l-47.39-27.36a1.06,1.06,0,0,1,1.06-1.83l47.39,27.35a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,364.86,166.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.53,204.9a1,1,0,0,1-.53-.14L395.9,184.5a1.06,1.06,0,0,1,1.06-1.84l35.1,20.27a1.06,1.06,0,0,1,.39,1.44A1.07,1.07,0,0,1,431.53,204.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,180.24a1,1,0,0,1-.53-.14L374,171.87a1.06,1.06,0,1,1,1.06-1.83l14.26,8.23a1.06,1.06,0,0,1,.39,1.44A1.07,1.07,0,0,1,388.82,180.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,182a1,1,0,0,1-.53-.14l-47.39-27.35a1.06,1.06,0,0,1,1.06-1.84L365.39,180a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.59,211.88a1,1,0,0,1-.53-.14L395.9,200.1a1.06,1.06,0,1,1,1.06-1.83l20.16,11.64a1.05,1.05,0,0,1,.39,1.44A1.07,1.07,0,0,1,416.59,211.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,195.85a1.13,1.13,0,0,1-.53-.14L374,187.48a1.06,1.06,0,0,1,1.06-1.84l14.26,8.23a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23,94.65a1,1,0,0,1-.53-.15L316.94,80.79A1.06,1.06,0,0,1,318,79l23.76,13.71a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,341.23,94.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,134.16a1.13,1.13,0,0,1-.53-.14L374,113.75a1.06,1.06,0,1,1,1.06-1.83l35.1,20.26a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,108.48a1,1,0,0,1-.53-.14l-14.26-8.23a1.06,1.06,0,0,1,1.06-1.84l14.26,8.23a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,365.19,108.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,116.54a1,1,0,0,1-.53-.15L316.94,89A1.06,1.06,0,0,1,318,87.2l47.39,27.36a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,364.86,116.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,140.16a1,1,0,0,1-.53-.14l-9.35-5.4a1.06,1.06,0,1,1,1.06-1.83l9.35,5.4a1.06,1.06,0,0,1,.39,1.44A1.07,1.07,0,0,1,405.78,140.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,113.84a1.13,1.13,0,0,1-.53-.14L336,108.3a1.06,1.06,0,0,1,1.06-1.84l9.35,5.4a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,130.37a1.13,1.13,0,0,1-.53-.14L374,122a1.06,1.06,0,0,1,1.06-1.84l14.26,8.23a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,106.19a1,1,0,0,1-.53-.14l-15.19-8.77A1.06,1.06,0,0,1,318,95.45l15.19,8.77a1.05,1.05,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,125a1,1,0,0,1-.53-.14L350.4,116.6a1.06,1.06,0,1,1,1.06-1.83L365.72,123a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,133.63a1,1,0,0,1-.53-.14l-47.39-27.36A1.06,1.06,0,0,1,318,104.3l47.39,27.35a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,364.86,133.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.53,172.12A1,1,0,0,1,431,172l-35.1-20.26a1.06,1.06,0,0,1,1.06-1.84l35.1,20.27a1.06,1.06,0,0,1,.39,1.44A1.07,1.07,0,0,1,431.53,172.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,147.46a1,1,0,0,1-.53-.14L374,139.09a1.06,1.06,0,1,1,1.06-1.83l14.26,8.23a1.07,1.07,0,0,1,.39,1.45A1.09,1.09,0,0,1,388.82,147.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23,128.23a1,1,0,0,1-.53-.14l-23.76-13.71a1.06,1.06,0,0,1,1.06-1.84l23.76,13.72a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,167.75a1,1,0,0,1-.53-.15L374,147.34a1.06,1.06,0,0,1,1.06-1.84l35.1,20.27a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,142.07a1.13,1.13,0,0,1-.53-.14l-14.26-8.24a1.06,1.06,0,1,1,1.06-1.83l14.26,8.23a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,365.19,142.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,150.12a1,1,0,0,1-.53-.14l-47.39-27.36a1.06,1.06,0,0,1,1.06-1.83l47.39,27.36a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,173.75a1.13,1.13,0,0,1-.53-.14l-9.35-5.4a1.06,1.06,0,1,1,1.06-1.83l9.35,5.39a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,147.43a1,1,0,0,1-.53-.15L336,141.89a1.06,1.06,0,0,1,1.06-1.84l9.35,5.4a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,164a1.13,1.13,0,0,1-.53-.14L374,155.59a1.06,1.06,0,0,1,1.06-1.84L389.35,162a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,139.78a1,1,0,0,1-.53-.14l-15.19-8.77A1.06,1.06,0,0,1,318,129l15.19,8.76a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,158.56a1,1,0,0,1-.53-.14l-14.26-8.23a1.06,1.06,0,0,1,1.06-1.84l14.26,8.24a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,163.23a1,1,0,0,1-.53-.14l-9.35-5.4a1.06,1.06,0,1,1,1.06-1.83l9.35,5.4a1.05,1.05,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,155.59a1.13,1.13,0,0,1-.53-.14l-15.19-8.77a1.06,1.06,0,0,1,1.06-1.84l15.19,8.77a1.06,1.06,0,0,1-.53,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,174.37a1.13,1.13,0,0,1-.53-.14L350.4,166a1.06,1.06,0,0,1,1.06-1.84l14.26,8.23a1.06,1.06,0,0,1,.38,1.45A1,1,0,0,1,365.19,174.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.85,82.83v38.34c0,.62-.22,1-.57,1.17h0l-1.47.81v-1.31l-.21-39.42,1.92-1A3.25,3.25,0,0,1,326.85,82.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,81.45l-1.92,1L278.11,55.16,277,54.52l1.53-.86.05,0h0a.85.85,0,0,1,.91.07l46,26.49A2.78,2.78,0,0,1,326.52,81.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,83.66v38.09a1.26,1.26,0,0,1-.44,1.09l-.09,0a.89.89,0,0,1-.85-.1l-45.7-26.33a3.29,3.29,0,0,1-1.38-2.63V55.75a1.25,1.25,0,0,1,.42-1.07.39.39,0,0,1,.14-.08.9.9,0,0,1,.82.11L323.81,81a2.69,2.69,0,0,1,1,1.19A3.36,3.36,0,0,1,325.19,83.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.87, -0.5, 0, 1, 316.95, 108.35)",
    style: {
      fontSize: "25.799850463867188px",
      fill: "#fafafa",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, "/"), /*#__PURE__*/React.createElement("path", {
    d: "M277.38,54.64a.82.82,0,0,1,.42.13l46,26.49a2.54,2.54,0,0,1,.92,1.09,3,3,0,0,1,.33,1.33V122a1,1,0,0,1-.3.87l-.08,0a.42.42,0,0,1-.2,0,1,1,0,0,1-.42-.13l-46-26.5a3.08,3.08,0,0,1-1.26-2.42V55.6a1.09,1.09,0,0,1,.31-.88l.09,0a.39.39,0,0,1,.18,0m0-.26a.67.67,0,0,0-.28.06l-.14.08a1.28,1.28,0,0,0-.41,1.08V93.91a3.35,3.35,0,0,0,1.38,2.65l46,26.49a1.1,1.1,0,0,0,.54.16.78.78,0,0,0,.31-.06l.09-.05a1.27,1.27,0,0,0,.44-1.1V83.68a3.4,3.4,0,0,0-.36-1.44,2.84,2.84,0,0,0-1-1.2l-46-26.49a1.13,1.13,0,0,0-.55-.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,55.63c0,1.09-.77,1.53-1.71,1a3.75,3.75,0,0,1-1.71-3c0-1.09.76-1.53,1.71-1A3.81,3.81,0,0,1,319.46,55.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,59.55c0,1.09-.77,1.54-1.72,1a3.78,3.78,0,0,1-1.71-3c0-1.09.77-1.54,1.71-1A3.78,3.78,0,0,1,325.82,59.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,63.48c0,1.09-.76,1.53-1.71,1a3.81,3.81,0,0,1-1.71-3c0-1.09.77-1.53,1.71-1A3.75,3.75,0,0,1,332.17,63.48Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.fb1642ce1c0c0cc0e4eec6a7f696c797.svg";
export { ForwardRef as ReactComponent };